<app-offcanvas-base
  [returnUrl]="returnUrl"
  [returnParams]="returnParams">
  <ng-container title>Change password</ng-container>
  <ng-container body>
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()"
        novalidate>
        <div class="h5 mb-4">Use this new password to sign in to your Paystashio app.</div>
        <bo-non-field-errors />
        <app-password-field boFieldPath="current_password" />
        <app-password-field boFieldPath="new_password" />
        @if (showHelpText('new_password')) {
          <p class="text-muted small">
            Password must contain at least 8 characters and contain mixed-case letters, numbers and special characters
          </p>
        }
        <app-password-field boFieldPath="confirm_password" />
        <p class="text-muted small mb-4">Both passwords must match</p>
        <div class="row gy-3 offcanvas-buttons">
          <div class="col-12 col-sm-auto">
            <app-offcanvas-cancel-btn [returnUrl]="returnUrl"></app-offcanvas-cancel-btn>
          </div>
          <div class="col-12 col-sm-auto ms-sm-auto">
            <app-submit
              btnID="savePasswordBtn"
              [busy]="busy"
              [icon]="false"
              label="Save password"></app-submit>
          </div>
        </div>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
